export default function encodeSearchQuery(string) {
  return string
    .replace(/\//g, '-')
    .replace(/-/g, '~')
    .replace(/,\s{1}/g, '--')
    .replace(/ /g, '-');
}
